import httpService from "./http.service";

class BlogsService {
    getBlogsUrl = "/blogs/admin";

    getBlogs = (query) => {
        return httpService.get(`/blogs/admin?${query}`);
    };
    createBlog = (model) => {
        return httpService.form("/blogs", model, "createBlog");
    };
    editBlog = (id, model) => {
        return httpService.form("/blogs/" + id, model, "editBlog", {}, "patch");
    };
    deleteBlog = (id) => {
        return httpService.delete("/blogs/" + id);
    };
    faqBlog = (id, model) => {
        return httpService.patch("/blogs/faq/" + id, model, "faqBlog", {}, "patch");
    };
}

const blogsService = new BlogsService();
export default blogsService;
